const dicClimatzoneCity = {
    1: 'Szczecin',
    2: 'Poznan',
    3: 'Warszawa',
    4: 'Bialystok',
    5: 'Suwalki'
}

export default dicClimatzoneCity